module.exports = __webpack_public_path__ + "static/media/detail_0024_t.917eb574.jpg";